export default function useLanguageTree (i18n) {
  const root = 'en-US'
  const supportedLanguages = new Map()
  supportedLanguages.set('en-US', root)
  supportedLanguages.set('es-ES', 'en-US')
  supportedLanguages.set('it-IT', 'en-US')
  supportedLanguages.set('ca-ES', 'es-ES')
  supportedLanguages.set('ca-AD', 'ca-ES')
  supportedLanguages.set('es-MX', 'es-ES')
  supportedLanguages.set('es-CO', 'es-ES')
  supportedLanguages.set('es-CL', 'es-ES')
  supportedLanguages.set('es-AR', 'es-ES')
  supportedLanguages.set('eu-ES', 'es-ES')

  function getAvailableLang (locale, targetObject, transformFunction) {
    let current = supportedLanguages.get(locale) ? locale : root
    const needTransformation = transformFunction && typeof transformFunction === 'function'

    while (current !== root && !!current) {
      if (targetObject[needTransformation ? transformFunction(current) : current]) {
        return needTransformation ? transformFunction(current) : current
      }
      const parent = supportedLanguages.get(current)
      if (targetObject[needTransformation ? transformFunction(parent) : parent]) {
        return needTransformation ? transformFunction(parent) : parent
      }
      current = parent
    }
    return needTransformation ? transformFunction(root) : root
  }

  function getObjectWithLangFallback (locale, targetObject, transformFunction) {
    let current = supportedLanguages.get(locale) ? locale : root
    const needTransformation = transformFunction && typeof transformFunction === 'function'

    while (current !== root && !!current) {
      if (targetObject[needTransformation ? transformFunction(current) : current]) {
        return targetObject[needTransformation ? transformFunction(current) : current]
      }
      const parent = supportedLanguages.get(current)
      if (targetObject[needTransformation ? transformFunction(parent) : parent]) {
        return targetObject[needTransformation ? transformFunction(parent) : parent]
      }
      current = parent
    }
    return targetObject[needTransformation ? transformFunction(root) : root] || null
  }

  function t (key, ...values) {
    let currentLocale = i18n.locale
    const currentTranslation = i18n._t(key, i18n.locale, i18n._getMessages(), null, ...values)
    if (!i18n.te(key, currentLocale)) {
      while (currentLocale !== i18n.fallbackLocale && currentLocale !== root && !!currentLocale) {
        currentLocale = supportedLanguages.get(currentLocale)
        if (i18n.te(key, currentLocale)) {
          return i18n._t(key, currentLocale, i18n._getMessages(), null, ...values)
        }
      }
    }
    return currentTranslation
  }

  async function getURLWithLangFallback (startEndpoint, locale, endEndpoint = '', transformFunction) {
    locale = supportedLanguages.get(locale) ? locale : root
    let currentLocale = locale
    let err = 'Endpoint not found'
    try {
      if (startEndpoint) {
        if (typeof transformFunction === 'function') {
          currentLocale = transformFunction(currentLocale)
        }
        const response = await fetch(`${startEndpoint}${currentLocale}${endEndpoint}`)
        if (response.ok) {
          return `${startEndpoint}${currentLocale}${endEndpoint}`
        }
        throw new Error(response.statusText)
      }
    } catch (e) {
      if (locale !== root) {
        return getURLWithLangFallback(startEndpoint, supportedLanguages.get(locale), endEndpoint, transformFunction)
      }
      err = new Error((err ? err.toString() : '') + '\n' + err)
      throw err
    }
    throw err
  }
  return {
    t,
    languagesRoot: root,
    supportedLanguages,
    getAvailableLang,
    getObjectWithLangFallback,
    getURLWithLangFallback
  }
}
